<template>
  <v-navigation-drawer
    clipped
    v-model="open"
    :width="dynamicWidth"
    fixed
    right
    app
    class="drawer subheading font-weight-bold"
  >
    <v-toolbar color="gainsboro" dense class="elevation-1 subheading" height="40">
      <strong>Item Summary</strong>
      <v-spacer></v-spacer>
      <div class="pr-3" v-if="showScrollControls">
        <v-btn
          icon
          small
          outline
          class="scroll-arrow ma-1"
          :disabled="!enableUpArrow"
          @click="moveTo(-scrollVal)"
          ><v-icon>keyboard_arrow_up</v-icon></v-btn
        >
        <v-btn
          icon
          small
          outline
          class="scroll-arrow ma-1"
          :disabled="!enableDownArrow"
          @click="moveTo(scrollVal)"
          ><v-icon>keyboard_arrow_down</v-icon></v-btn
        >
      </div>
      <v-btn flat icon color="error" @click="closeSummary()">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-text-field
          v-model.trim="searchText"
          placeholder="Search"
          solo
          flat
          hide-details
          prepend-inner-icon="search"
          clearable
          append-icon="filter_list"
          @click:append="splitOption = !splitOption"
        ></v-text-field>
        <v-divider></v-divider>
        <!-- @input="act()" -->
      </v-flex>
      <v-flex xs12 v-if="splitOption">
        <v-layout wrap class="split pa-2 px-3">
          <v-flex xs12>Split Items By</v-flex>
          <v-flex xs6>
            <v-checkbox
              v-model="splitByCuisine"
              @change="check(1, splitByCuisine)"
              dense
              label="Cuisine"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              v-model="splitByCategory"
              @change="check(2, splitByCategory)"
              dense
              label="Category"
              hide-details
            ></v-checkbox>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout
      align-center
      justify-center
      row
      class="no-items"
      v-if="!filteredItems.length"
    >
      <v-flex xs12 text-xs-center class="grey--text">
        <h2 class="subheading grey--text">
          No orders available, please wait
          <v-icon color="orange">directions_walk</v-icon>
          <v-icon color="red">directions_run</v-icon>
        </h2>
      </v-flex>
    </v-layout>

    <detail
      ref="summary_cont"
      :items="filteredItems"
      :selectItem="selectItem"
      :selected="selected"
      :splitOption="splitOption"
      v-if="!splitByCuisine && !splitByCategory"
    ></detail>

    <div v-else :class="splitOption ? 'items-list-master' : 'items-list'">
      <v-expansion-panel :value="0">
        <v-expansion-panel-content
          v-for="(master, i) in filteredByMaster"
          :key="i"
        >
          <div slot="header">
            <span class>
              <strong>{{ master.name }} ({{ master.kds_items.length }})</strong>
            </span>
          </div>
          <detail
            :items="master.kds_items"
            :selectItem="selectItem"
            :selected="selected"
            :splitOption="splitOption"
          ></detail>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </v-navigation-drawer>
</template>

<style scoped>
.drawer {
  overflow: hidden;
}
.no-items {
  height: calc(100vh - 164px);
}
.items-list {
  max-height: calc(100vh - 156px);
  overflow-y: auto;
}
.items-list-master {
  max-height: calc(100vh - 222px);
  overflow-y: auto;
}
.item-qty--action.v-list__tile__action {
  min-width: 35px !important;
}

.items .v-list--dense .v-list__tile {
  min-height: 40px;
  height: auto !important;
}

.items .v-list__tile {
  height: 56px !important;
}

.items .v-list__tile__action {
  min-width: auto;
}

.split .v-input--selection-controls {
  margin-top: 0px !important;
}
.theme--light.v-expansion-panel--focusable .v-expansion-panel__container:focus {
  background-color: transparent !important;
}
</style>


<script>
import { mapState } from "vuex";
import Detail from "./detail";

export default {
  name: "item-list",
  components: { Detail },
  props: {
    enable: Boolean,
    items: {
      type: Array,
      required: true
    },
    selectedItem: Number
  },
  data() {
    return {
      selected: 0,
      searchText: null,
      splitOption: false,
      splitByCuisine: false,
      splitByCategory: false,
      enableUpArrow: false,
      enableDownArrow: true,
      scrollVal: 50,
      showScrollBtn: false
    };
  },
  methods: {
    check(t, state) {
      if (t == 1) {
        if (state) this.splitByCategory = false;
      }
      if (t == 2) {
        if (state) this.splitByCuisine = false;
      }
    },
    selectItem(item) {
      let data = item.id != this.selected ? item.id : null;
      this.selected = data;
      this.$emit("update:selectedItem", data);
    },
    closeSummary() {
      this.open = false;
      this.selected = null;
      this.$emit("update:selectedItem", null);
    },
    onScroll(evt) {
      let elem = this.$refs.summary_cont;
      let scrollElm = elem.$children[0].$el;
      if (scrollElm) {
        this.enableUpArrow = scrollElm.scrollTop > 0;
        this.enableDownArrow =
          scrollElm.scrollHeight > scrollElm.scrollTop + scrollElm.clientHeight;
      }
    },
    moveTo(px) {
      this.$nextTick(() => {
        let elem = this.$refs.summary_cont;
        let scrollElm = elem.$children[0].$el;
        if (scrollElm) {
          if (px > 0) {
            scrollElm.scrollTop += px;
          } else {
            if (
              scrollElm.scrollTop > this.scrollVal &&
              scrollElm.scrollTop < this.scrollVal
            ) {
              scrollElm.scrollTop = 0;
              return;
            }
            scrollElm.scrollTop += px;
          }
        }
      });
    },
    addScrollEvtListener() {
      let elem = this.$refs.summary_cont;
      let scrollElm = elem.$children[0].$el;
      if (scrollElm) {
        this.showScrollBtn = scrollElm.scrollHeight > scrollElm.clientHeight;
        scrollElm.addEventListener("scroll", this.onScroll);
      }
    }
  },
  watch: {
    selectItem(item) {
      this.selected = item;
    },
    selectedItem(v) {
      this.selected = v;
    }
  },
  computed: {
    ...mapState(["cuisines", "categories"]),
    filteredItems() {
      const searchText = this.searchText ? this.searchText.toLowerCase() : null;

      if (!searchText) return this.items;

      return this.items.filter((item) => {
        if (item.name.toLowerCase().indexOf(searchText) === -1) return false;
        return true;
      });
    },
    filteredByMaster() {
      const searchText = this.searchText ? this.searchText.toLowerCase() : null;
      let items = [];

      if (!searchText) items = this.items;
      else {
        items = this.items.filter((item) => {
          if (item.name.toLowerCase().indexOf(searchText) === -1) return false;

          return true;
        });
      }

      let itemIds = items.map((i) => i.id);

      if (this.splitByCuisine) {
        let filteredCuisines = Object.values(this.cuisines).filter((c) => {
          return c.menuItems.some((r) => itemIds.indexOf(r) >= 0);
        });

        filteredCuisines.map((c) => {
          c.kds_items = items.filter((i) => c.menuItems.includes(i.id));
          return c;
        });

        return filteredCuisines;
      }

      if (this.splitByCategory) {
        let filteredCategories = Object.values(this.categories).filter((c) => {
          return c.menuItems.some((r) => itemIds.indexOf(r) >= 0);
        });

        filteredCategories.map((c) => {
          c.kds_items = items.filter((i) => c.menuItems.includes(i.id));
          return c;
        });

        return filteredCategories;
      }

      return [];
    },
    open: {
      get() {
        return this.enable;
      },
      set(e) {
        this.$emit("update:enable", e);
      }
    },
    settings() {
      return this.$store.getters.nodeSettings;
    },
    dynamicWidth() {
      let widths = this.$store.getters.nodeSettings;
      return widths.width.value + "px";
    },
    showScrollControls() {
      return this.settings.showScrollControls && this.showScrollBtn;
    }
  },
  mounted() {
    this.addScrollEvtListener();
  },
  updated() {
    this.addScrollEvtListener();
  }
};
</script>
